<template>
    <div class="house-verify-mask">
        <div class="mask-box">
            <div class="mask-lock"><i class="iconfont icon-lock1"></i></div>
            <div class="mask-text">Email Verification Required</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'verify-mask',
    i18next: {
        ns: 'md-listing-list'
    }
}
</script>

<style lang="scss">
.house-verify-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: var(--level-low);
    background: var(--mask-bg-color);
    cursor: pointer;
    .mask-box {
        font-size: 14px;
        text-align: center;
        color: var(--mask-text-color);
        padding: 0 20px;
        .mask-lock {
            width: 30px;
            height: 30px;
            line-height: 30px;
            margin: 0 auto;
            background: var(--color-theme);
            border-radius: 50%;
            .icon-lock1 {
                font-size: 14px;
                color: #fff;
            }
        }
        .mask-text {
            margin-top: 15px;
            white-space: nowrap;
            font-family: var(--font-bold);
            color: var(--mask-text-color);
            transform: scale(0.6);
        }
    }
}
</style>